import { useMemo, useState, useEffect, useCallback } from "react";
import { useTable } from "react-table";
import middleware from "../Api/Middleware";
import TablePreset from "../Table/TablePreset";
import "../Table/Table.css";
import "./Orders.css";
import { useNavigate } from "react-router";
import { format } from 'date-fns';
import { nl } from 'date-fns/locale';
import PageTemplate from "../Templates/PageTemplate";
import TDSTextNavigation from "../Templates/TDSTextNavigation";
import CheckboxHeader from "../Table/TableComponents/CheckboxHeader";
import CheckboxCell from "../Table/TableComponents/CheckboxCell";
import SortableHeader from "../Table/TableComponents/SortableHeader";
import Filters from "../Filters/Filters";
import { generatePackingSlip } from '../generatePDF/GeneratePackingSlip';
import ToastError from '../Toasts/ToastError';
import ToastWarning from "../Toasts/ToastWarning";
import { formatCurrency } from "../../utils";
import generateInvoice from "../generatePDF/GenerateInvoice";
import axios from "axios";

// Status display components with proper sorting
export const GetOrderStatus = ({ orderStatus }) => {
  switch (orderStatus) {
    case 0:
      return <label className="">Geannuleerd</label>;
    case 1:
      return <label className="DarkBlueText">Concept</label>;
    case 2:
      return <label className="OrangeText">Nieuw</label>;
    case 3:
      return <label className="OrangeText">Deels in behandeling</label>;
    case 4:
      return <label className="BlueText">In behandeling</label>;
    case 5:
      return <label className="GreenText">Voltooid</label>;
    default:
      return "-";
  }
};

export const GetPaymentStatus = ({ paymentStatus }) => {
  switch (paymentStatus) {
    case 1:
      return <label className="DarkBlueText">Concept</label>;
    case 2:
      return <label className="OrangeText">Openstaand</label>;
    case 3:
      return <label className="OrangeText">Deels betaald</label>;
    case 4:
      return <label className="OrangeText">Op factuur</label>;
    case 5:
      return <label className="GreenText">Volledig betaald</label>;
    case 6:
      return <label className="">Geannuleerd</label>;
    default:
      return "-";
  }
};

export const GetDeliveryStatus = ({ deliveryStatus }) => {
  switch (deliveryStatus) {
    case 1:
      return <label className="DarkBlueText">Concept</label>;
    case 2:
      return <label className="OrangeText">Deels verzonden</label>;
    case 3:
      return <label className="BlueText">Verzonden</label>;
    case 4:
      return <label className="GreenText">Afgeleverd</label>;
    default:
      return "-";
  }
};

const Orders = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [salesChannels, setSalesChannels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPage, setLoadingPage] = useState(true);
  const [data, setData] = useState([]);
  const [orderIds, setOrderIds] = useState([]);
  const [searchBar, setSearchBar] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [pagination, setPagination] = useState({
    page_size: 10,
    page: 1,
    max_items: 0,
    begin_of_page: 0,
    end_of_page: 0,
  });
  const [order, setOrder] = useState({ orderBy: '', direction: '' });
  const [generatingPackingSlips, setGeneratingPackingSlips] = useState(false);
  const defaultFilters = [
    { index: 0, order: 1, name: "Datum", field: 'time_of_order', type: "daterange" },
    { index: 1, order: 2, name: "Prijs", field: 'total_price_incl_tax', type: "range" },
    { index: 2, order: 3, name: "Verkoopkanaal", field: 'sales_channel_id', type: "dropdown", options: 'salesChannels' },
    { index: 3, order: 4, name: "Status", field: 'order_status', type: "dropdown", options: [{ name: "Concept", value: 1 }, { name: "Nieuw", value: 2 }, { name: "Deels in behandeling", value: 3 }, { name: "In behandeling", value: 4 }, { name: "Voltooid", value: 5 }, { name: "Geannuleerd", value: 0 }] },
    { index: 4, order: 5, name: "Betaling", field: 'payment_status', type: "dropdown", options: [{ name: "Geen betaling", value: 0 }, { name: "Concept", value: 1 }, { name: "Openstaand", value: 2 }, { name: "Deels betaald", value: 3 }, { name: "Volledig betaald", value: 5 }, { name: "Op factuur", value: 4 }, { name: "Geannuleerd", value: 6 }] },
    { index: 5, order: 6, name: "Verzending", field: 'delivery_status', type: "dropdown", options: [{ name: "Geen verzending", value: 0 }, { name: "Concept", value: 1 }, { name: "Deels verzonden", value: 2 }, { name: "Verzonden", value: 3 }, { name: "Afgeleverd", value: 4 }] },
  ];
  const [exportShippingInstalled, setExportShippingInstalled] = useState(JSON.parse(localStorage.getItem("appstore")));
  const [tempfilters, setTempFilters] = useState(defaultFilters);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const filterString = () => {
    if (filters.filter(e => e.value).length) {
      let string = "&filtering=";
      filters.filter(e => e.value).map((e) => {
        switch (e.type) {
          case 'radio':
            string += e.field;
            string += "=";
            string += e.value;
            string += "|"

            break;
          case 'hasradio':
            string += e.field;
            e.value == 0 ? string += "=,0" : string += '!=,0';
            string += "|"

            break;
          case 'range':
            if (e.value.min || e.value.max) {
              string += e.field;
              string += "<>";

              string += ((e.value.min != null && e.value.min != '') ? e.value.min : '-1') + ','
              string += ((e.value.max != null && e.value.max != '') ? e.value.max : 'null')
              string += "|"
            }
            break;
          case 'daterange':
            if (e.value.min || e.value.max) {
              string += e.field;
              string += "<>";

              string += ((e.value.min != null && e.value.min != '') ? e.value.min : 'null') + ','
              string += ((e.value.max != null && e.value.max != '') ? e.value.max : 'null')
              string += "|"
            }
            break;
          case 'dropdown':
            string += e.field;
            string += "=";
            string += e.value;
            string += "|"
            break;
          case 'category':
            string += e.field;
            string += "=";
            string += e.value;
            string += "|"
            break;
        }
      });
      return string;
    } else {
      return "";
    }
  }

  const CloseFilterModal = () => {
    setShowFilterModal(false);
  }

  const fetchAll = async () => {
    setLoading(true);
    try {
      const paginationQuery = `page=${pagination.page}&page_size=${pagination.page_size}`;

      // Enhanced order query handling for numeric fields
      let orderQuery = '';
      if (order.orderBy && order.direction) {
        const numericFields = ['order_status', 'payment_status', 'delivery_status'];
        const isNumericField = numericFields.includes(order.orderBy);

        orderQuery = `&orderBy=${order.orderBy}&orderDirection=${order.direction}${isNumericField ? '&numeric=true' : ''}`;
      }

      let searchQuery = '';
      if (searchBar.trim()) {
        const terms = searchBar
          .trim()
          .split(' ')
          .filter(term => term.length > 0);

        if (terms.length > 0) {
          searchQuery = `&searchTerm=${encodeURIComponent(terms.join(' '))}` +
            '&noSearch=["order_id","internal_id","time_of_order",' +
            '"items_sent","items_total","created_at","order_status",' +
            '"payment_status","delivery_status"]';
        }
      }

      const [ordersResponse, consumersResponse, salesChannelsResponse] = await Promise.all([
        middleware.get(`sp/ordersTableAll?${paginationQuery}${orderQuery}${searchQuery}` + filterString()),
        middleware.get(`sp/getAllCustomersFromOrders`),
        middleware.get(`saleschannels`),
      ]);

      const newData = ordersResponse.data.data;
      setCustomers(consumersResponse.data);
      setSalesChannels(salesChannelsResponse.data.data);
      setData(newData);
      setOrderIds(newData.map(data => data.order_id));
      setPagination(prev => ({
        ...prev,
        max_items: ordersResponse.data.total,
        begin_of_page: ordersResponse.data.from,
        end_of_page: ordersResponse.data.to
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingPage(false)
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAll();
  }, [pagination.page, pagination.page_size, order.orderBy, order.direction, searchBar, filters]);

  const handleSearchChange = useCallback((value) => {
    setSearchBar(value);
    setPagination(prev => ({ ...prev, page: 1 }));
  }, []);

  const handleSelection = (productId, isSelected) => {
    if (isSelected) {
      setSelectedIds((previous) => [...previous, productId]);
    } else {
      setSelectedIds((previous) => previous.filter((id) => id !== productId));
    }
  };

  // Main function to handle multiple selected IDs
  const handleGeneratePackingSlips = async () => {
    if (!selectedIds || selectedIds.length === 0) {
      ToastError("Geen bestellingen geselecteerd", "no_orders_selected");
      return;
    }

    setGeneratingPackingSlips(true);

    generatePackingSlip(selectedIds, true);
    
    setGeneratingPackingSlips(false);
  };

  const handleGenerateInvoices = async () => {
    if (!selectedIds || selectedIds.length === 0) {
      ToastError("Geen bestellingen geselecteerd", "no_orders_selected");
      return;
    }

    setGeneratingPackingSlips(true);

    generateInvoice(selectedIds, true);
    
    setGeneratingPackingSlips(false);
  }

  const columns = useMemo(
    () => [
      {
        Header: (
          <CheckboxHeader
            currentItem={data}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            pk={'order_id'}
          />
        ),
        accessor: "select",
        Cell: ({ row }) => {
          return (
            <CheckboxCell
              row={row}
              handleSelection={handleSelection}
              selectedIds={selectedIds}
              pk={'order_id'}
            />
          );
        }
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={(newOrder) => {
              setOrder(newOrder);
              setPagination(prev => ({ ...prev, page: 1 }));
            }}
            field="order_number"
          >
            Bestelling
          </SortableHeader>
        ),
        accessor: 'order_number',
        Cell: ({ row }) => {
          const orderNumber = row.original.order_number || "";
          const ownerName = row.original.owner_name || "";
          const internalId = row.original.internal_id || "";
          const date = format(new Date(row.original.time_of_order), 'dd MMMM yyyy HH:mm', { locale: nl });
          return (
            <div className="d-flex flex-column">
              <TDSTextNavigation
                text={orderNumber || '-'}
                extraClassNames={"text-nowrap"}
                link={`/bestellingen/overzicht/${orderNumber}`}
                openNewTab={false}
              />
              {ownerName || "-"}
              <div>
                <label>{date || "-"}</label>
              </div>
            </div>
          );
        }
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={(newOrder) => {
              setOrder(newOrder);
              setPagination(prev => ({ ...prev, page: 1 }));
            }}
            field="total_price_incl_tax"
          >
            Prijs incl.
          </SortableHeader>
        ),
        accessor: 'total_price_incl_tax',
        Cell: ({ row }) => {
          // const price = `€ ${Number(row.original.total_price_incl_tax).toFixed(2).replace('.', ',').replace(',00', ',-')}`;
          const price = formatCurrency(row.original.total_price_incl_tax);
          return <div className="text-nowrap">{price}</div>;
        }
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={(newOrder) => {
              setOrder(newOrder);
              setPagination(prev => ({ ...prev, page: 1 }));
            }}
            field="sales_channel_name"
            pos={"center"}
          >
            Verkoopkanaal
          </SortableHeader>
        ),
        accessor: 'sales_channel_name',
        Cell: ({ row }) => (
          <div className="d-flex flex-column">
            {row.original.sales_channel_name || "-"}
          </div>
        )
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={(newOrder) => {
              setOrder(newOrder);
              setPagination(prev => ({ ...prev, page: 1 }));
            }}
            field="order_status"
          >
            Status
          </SortableHeader>
        ),
        accessor: 'order_status',
        sortType: 'number',
        Cell: ({ row }) =>
          <div>
            <GetOrderStatus orderStatus={row.original.order_status} />
          </div>
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={(newOrder) => {
              setOrder(newOrder);
              setPagination(prev => ({ ...prev, page: 1 }));
            }}
            field="payment_status"
            pos={"center"}
          >
            Betaling
          </SortableHeader>
        ),
        accessor: 'payment_status',
        sortType: 'number',
        Cell: ({ row }) =>
          <div>
            <GetPaymentStatus paymentStatus={row.original.payment_status} />
          </div>
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={(newOrder) => {
              setOrder(newOrder);
              setPagination(prev => ({ ...prev, page: 1 }));
            }}
            field="delivery_status"
            pos={"center"}
          >
            Verzending
          </SortableHeader>
        ),
        accessor: 'delivery_status',
        sortType: 'number',
        Cell: ({ row }) => (
          <div>
            <GetDeliveryStatus
              deliveryStatus={row.original.delivery_status}
            />
          </div>

        )
      },
    ],
    [order.orderBy, order.direction, selectedIds, setSelectedIds, data]
  );

  const tableInstance = useTable({ columns, data });

  // a function that selects all the selects in the table
  const select_all = () => {
    setSelectedIds(data.map((order) => order.order_id));
  };

  // a function that unselects all the selects in the table
  const unselect_all = () => {
    setSelectedIds([]);
  };

  const Action = (methode) => {
    if (methode == "Select All") {
      select_all();
    } else if (methode == "De-select All") {
      unselect_all();
    }
  };

  async function exportShipping()
  {
    try {
      const dt = await middleware.get(
        "orders/generateCsv/" + JSON.stringify([...new Set(selectedIds)])
      );

      const link = document.createElement("a");

      // Set link's href to point to the Blob URL
      link.href = URL.createObjectURL(new Blob([dt.data.data.response]));
      link.download = "shipping_address_export.csv";
      if (dt.data.data.failure.length > 0)
        ToastWarning(
          <p>
            Voor de orders
            <br />
            {dt.data.data.failure.join("<br/>")}
            <br />
            kunnen de gegevens niet geexporteerd worden
          </p>
        );

      // Append link to the body
      document.body.appendChild(link);

      // Dispatch click event on the link
      link.click();
      //    link.dispatchEvent(
      //      new MouseEvent("click", {
      //        bubbles: true,
      //        cancelable: true,
      //        view: window,
      //      })
      //    );
      //
      // Remove link from body
      document.body.removeChild(link);
    } catch (e) {
      const er = e.response?.data?.error;
      if (er) ToastError(er);
      else console.error(e);
    }
  }

  return (
    <PageTemplate navbarTitle={"Order HUB"} pageIsLoading={loadingPage} >
      <div className="orderTableOverview w-100">
        <div className="orderTable">
          <TablePreset
            data={[{ 'selectedIds': selectedIds, 'tableInstance': tableInstance, 'pagination': pagination, 'primary_key': 'order_id' }]}
            tableLoading={loading}
            setPagination={setPagination}
            handleSelection={handleSelection}
            searchBar={[{ shown: true, searchFunction: handleSearchChange, placeholder: "Zoeken op bestelling, klant, etc." }]}
            actionOptions={[
              { title: "Selecteer alles", function: () => Action("Select All") },
              { title: "De-selecteer alles", function: () => Action("De-select All") },
              { title: "Print Pakbon(nen)", function: () => handleGeneratePackingSlips() },
              { title: "Print Factuur(en)", function: () => handleGenerateInvoices() },
              ...(exportShippingInstalled?.apps?.find(app => app.slug === "shipping-export")?.status === 3 ?[{title: (<span>Exporteer bezorg-<br/>adressen</span>), function: () => exportShipping()}]:[] )
            ]}
            leftButtons={[{ title: "Filteren", function: () => setShowFilterModal(true) }]}
            rightButtons={[{ title: "Nieuwe bestelling", function: () => navigate('/bestellingen/nieuw') }]}
          />
        </div>
      </div>
      <Filters
        filters={tempfilters}
        props={{ salesChannels: salesChannels.map((salesChannel) => { return { name: salesChannel.sales_channel_name, value: salesChannel.sales_channel_id } }) }}
        showFilterModal={showFilterModal}
        closeFilterModal={CloseFilterModal}
        setTempFilters={setTempFilters}
        setFilters={setFilters}
        defaultFilters={defaultFilters}
      />
    </PageTemplate>
  );
}

export default Orders;